if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    setTimeout( () => {
        $('#event_date').datepicker();
        $('[name=event_date]').datepicker();
        flatpickr( "[name=event_date]" );
    }, 1000 )

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.reviews').slick({
        fade:true,
        accessibility: false,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                arrows:false,
                dots: true,
                adaptiveHeight:true
              }
            }
        ]
    })


    document.getElementById("id_8_4223").addEventListener("focus", function() {        
        this.classList.add("no-before");
    });


})();